import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  chartContainer: {
    width: '100%',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridAutoRows: 'auto',
    gap: '5px 30px',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
    [theme.breakpoints.up('lg')]: {
      width: '100%',
    },
    [theme.breakpoints.up('xl')]: {
      width: '85%',
    },
  },
  chartItem: {
    backgroundColor: 'transparent',
    border: '0.5px solid var(--border-color)',
    borderRadius: '10px',
    color: 'var(--text-color)',
    textAlign: 'left',
    margin: '5px 0',
    padding: '5px 10px',
  },
  showMoreButton: {
    width: 190,
    color: '#fff !important',
    fontWeight: '900 !important',
    height: 40,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    marginTop: '10px !important',
    backgroundImage: (props) => `url("${props.bgBtn}")`,
    margin: '0 auto !important',
    '&:hover': {
      filter: 'brightness(120%)',
      boxShadow: 'none',
      backgroundColor: 'rgba(255, 255, 128, 0)',
      transform: 'scale(1.05) rotate(-2.5deg)',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  dateInfo: {
    fontSize: '12px !important',
    opacity: 0.7,
    marginLeft: '4px',
    fontStyle: 'italic',
  },
}));
